import type { TFunction } from 'i18next';

/**
 * The client-labelled badge text. Shared by the screen badge and the printed
 * pick list, so the two never drift.
 */
export function clientLabelledLabel(t: TFunction<'production'>, clientName?: string | null): string {
  return clientName
    ? t('picking.badges.clientNameLabelled', { client: clientName })
    : t('picking.badges.clientLabelled');
}
